export default {
  es: {
    "app.home.index.logout": "salir",
    "app.home.index.visitas": "Visitas",
    "app.home.index.usuarios": "Usuarios",
    "app.home.index.promociones": "Promociones",
    "app.home.index.tipos-inmuebles": "Tipos de inmuebles",
    "app.home.index.salir": "Salir",
  },
};